import BaseService from './BaseService'

class LinkService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  list = (locationId: string) => this.requests.get(`/?locationId=${locationId}`)
  delete = (linkId: string) =>
    this.requests.delete(`/${linkId}`)
}

const instance = new LinkService(BaseService.servicesConfig.Links)

export default instance